import { FC } from 'react';

import BoxInfoOffer from '@/components/ui/BoxInfoOffer';

import { useLingui } from '@lingui/react';

interface Props {
  name: string;
  address: string;
}

const DefendantInfo: FC<Props> = ({ name, address }) => {
  const { i18n } = useLingui();

  return (
    <div className="text-dark-gray-500 lg:max-w-[440px]">
      <h2 className="h4 mb-3 text-center">{i18n.t('Strona pozwana')}</h2>
      <div className="mb-4 hidden h-px w-full bg-dark-gray-100 lg:block" />
      <div className="grid gap-2 lg:gap-x-5 lg:gap-y-3">
        <BoxInfoOffer label={i18n.t('Nazwa podmiotu')} value={name} />
        <BoxInfoOffer label={i18n.t('Adres')} value={address} />
      </div>
    </div>
  );
};

export default DefendantInfo;
